import React, { useCallback } from "react";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import isNumber from "../../utils/isNumber";

const AddToCartQuantity = ({
  value,
  min,
  max,
  onDecrement,
  onIncrement,
  onChange,
  errorMessage,
}) => {
  const handleChange = useCallback(
    (event) => {
      onChange(event.target.value);
    },
    [onChange]
  );

  const incrementButtonDisabled = !isNumber(value) || value >= max;

  const decrementButtonDisabled = !isNumber(value) || value <= min;

  return (
    <>
      <div className="pdp-main-block__subsection">
        <h6 className="pdp-main-block__qty-label">Qty</h6>

        <div className="qty-amount-switch">
          <button
            id="pdp-product-qty-button-dec"
            className="qty-amount-switch__btn js-qty-amount--dec"
            onClick={onDecrement}
            disabled={decrementButtonDisabled}
          >
            -
          </button>
          <span className="qty-amount-switch__field-wrapper">
            <input
              id="pdp-product-qty"
              type="number"
              min={min}
              max={max}
              value={value}
              className="qty-amount-switch__field"
              onChange={handleChange}
            />
          </span>
          <button
            id="pdp-product-qty-button-inc"
            className="qty-amount-switch__btn js-qty-amount--inc"
            onClick={onIncrement}
            disabled={incrementButtonDisabled}
          >
            +
          </button>
        </div>
      </div>

      {errorMessage && (
        <div className="pdp-main-block__subsection pdp-main-block__qty-error">
          <ErrorMessage size={"small"}>{errorMessage}</ErrorMessage>
        </div>
      )}
    </>
  );
};

export default AddToCartQuantity;
